<template>
  <div class="page-job">
    <div class="g-wrap">
      <el-breadcrumb class="g-breadcrumb" separator="/">
        <el-breadcrumb-item :to="`${$subsitePrefix}/ss`"
          >社会服务</el-breadcrumb-item
        >
        <el-breadcrumb-item>岗位实践</el-breadcrumb-item>
      </el-breadcrumb>
      <div class="g-content content">
        <job-card
          v-for="item in jobList"
          :data="item"
          :key="item.id"
        ></job-card>
        <el-pagination
          v-if="total > pageSize"
          class="g-pagination"
          background
          layout="prev, pager, next"
          :current-page="pageIndex"
          :page-size="pageSize"
          :total="total"
          @current-change="handleIndexChange"
        >
          ></el-pagination
        >
      </div>
    </div>
  </div>
</template>

<script>
import { getData } from "api/app";
import Card from "./Card";
import { mapState } from "vuex";
export default {
  data() {
    return {
      jobList: [],
      total: 0,
      pageSize: 10,
      pageIndex: 1
    };
  },
  created() {
    this.init();
  },
  computed: {
    ...mapState("college", ["collegeData", "currentMajor"])
  },
  components: {
    [Card.name]: Card
  },
  methods: {
    handleIndexChange(index) {
      this.pageIndex = index;
      this.loadData();
    },
    loadData() {
      var queryParams = {
        name: "PracticeJob",
        index: this.pageIndex,
        size: this.pageSize ?? 10,
        params: [
          {
            Key: "College",
            Value: this.collegeData.college.Id,
            CompareType: "EqualTo"
          }
        ]
      };
      getData(queryParams).then(res => {
        this.jobList = res.Data || [];
        this.total = res.TotalCount;
      });
    },
    init() {
      this.loadData();
    }
  }
};
</script>

<style lang="scss" scoped>
.page-job {
  background: #f6f6f9;
  padding-bottom: 40px;
  ::v-deep .comp-job {
    margin: 0 48px;
  }
  .content {
    padding-bottom: 48px;
    .g-pagination {
      margin-top: 24px;
    }
  }
}
</style>
